module.exports = __webpack_public_path__ + "img/grantStarCoinTopBg.bca672dd.png";